import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "../styles/navbar.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserContext from "../context/user/UserContext";
import Skeleton from "@mui/material/Skeleton";
import StateContext from "../context/state/StateContext";
import { PiTicket } from "react-icons/pi";
import { AiOutlineUser } from "react-icons/ai";
import { VscBell } from "react-icons/vsc";
import Fuse from "fuse.js";
import axios from "axios";
import NotificationContainer from "./NotificationContainer";
import { MdOutlineBusiness } from "react-icons/md";
import { toast } from "react-toastify";

const Navbar = () => {
  const {
    user,
    getUser,
    getClients,
    getEmployees,
    verifyUser,
    user_verified,
    fetchNotifications,
    fetchGroupDetails,
    getAgencies,
    getTags
  } = useContext(UserContext);
  const { setModal, setConfirm, notifications } = useContext(StateContext);
  const token = localStorage.getItem("token");
  const [menu, setMenu] = useState(false);
  const [openSide, setOpenSide] = useState(false);
  const [noteContainer, setNoteContainer] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user_verified) {
      getUser();
    }
    // let shown = localStorage.getItem("shown");
    // setTimeout(() => {
    //   if (shown && parseInt(shown) < 1) {
    //     introJs()
    //       .setOptions({
    //         steps: [
    //           {
    //             element: "#mbtn-1",
    //             intro: "Introducing Our Exciting New AI Feature – Take a Look!",
    //           },
    //         ],
    //       })
    //       .start();
    //     localStorage.setItem("shown", parseInt(shown) + 1);
    //   }else if(!shown){
    //     introJs()
    //     .setOptions({
    //       steps: [
    //         {
    //           element: "#mbtn-1",
    //           intro: "Introducing Our Exciting New AI Feature – Take a Look!",
    //         },
    //       ],
    //     })
    //     .start();
    //   localStorage.setItem("shown", 1);
    //   }
    // }, 1000);
  }, []);

  useEffect(() => {
    fetchNotifications();
    fetchGroupDetails();
    getEmployees();
    getAgencies();
    getTags();
    const checkUser = async () => {
      try {
          const response = await axios.get(process.env.REACT_APP_API_URL + "api/auth/getUser", {
              headers: {
                  'Content-Type': "application/json",
                  'auth-token': `${token}`
              }
          });

          const json = response.data;
          if (json.success) {
              return;
          } else {
              console.log(json.message);
              toast.error(json.error || json.message || "Some Error occurred");
              navigate("/");
          }
      } catch (error) {
          console.error(error);
          navigate("/");
      }
  };
  checkUser()
  }, []);

  const menuRef = useRef(null);
  const noteRef = useRef(null);

  const handleModelCLickedOutside = (event) => {
    if (!menuRef.current) return; // Ensure menuRef exists before checking

    if (!menuRef.current.contains(event.target)) {
      // setMenu(false);
    }
  };

  const handleNotificationModel = (event) => {
    if (noteRef.current && !noteRef.current.contains(event.target)) {
      setNoteContainer(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleNotificationModel);
    return () => {
      document.removeEventListener("mousedown", handleNotificationModel);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleModelCLickedOutside);
    return () => {
      document.removeEventListener("mousedown", handleModelCLickedOutside);
    };
  }, []);

  const unreadNotificationsLength = Array.isArray(notifications)
    ? notifications.filter((notification) => !notification.isRead).length
    : 0;

  return (
    <>
      <nav>
        <div className={styles.top_panel}>
          <div className="d-flex align-items-center">
            <div className={styles.logo}>
              <img src="/images/logo-w.png" className="img-fluid" alt="" />
              <h5 className="mt-2">Ackroll</h5>
            </div>
          </div>
          <div className={styles.top_menu}>
            <ul
              ref={menuRef}
              className={`${styles.top_links} ${menu ? styles.active : ""}`}
            >
            {user.role != "agency" ? (<li
                onClick={() => {
                  setMenu(false);
                }}
              >
                <a href="/dashboard">
                  <svg viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg">
                    <path
                      clipRule="evenodd"
                      d="M11.1693 17.213C10.6953 17.213 10.311 16.8287 10.311 16.3547V10.3469C10.311 9.87289 10.6953 9.4886 11.1693 9.4886H17.1772C17.6512 9.4886 18.0354 9.87289 18.0354 10.3469V16.3547C18.0354 16.8287 17.6512 17.213 17.1772 17.213H11.1693ZM12.0276 15.4965H16.3189V11.2051H12.0276V15.4965ZM1.72835 17.213C1.25432 17.213 0.870079 16.8287 0.870079 16.3547V10.3469C0.870079 9.87289 1.25432 9.4886 1.72835 9.4886H7.73622C8.21025 9.4886 8.59449 9.87289 8.59449 10.3469V16.3547C8.59449 16.8287 8.21025 17.213 7.73622 17.213H1.72835ZM2.58661 15.4965H6.87795V11.2051H2.58661V15.4965ZM11.1693 7.77205C10.6953 7.77205 10.311 7.38776 10.311 6.91378V0.905909C10.311 0.431934 10.6953 0.0476412 11.1693 0.0476412H17.1772C17.6512 0.0476412 18.0354 0.431934 18.0354 0.905909V6.91378C18.0354 7.38776 17.6512 7.77205 17.1772 7.77205H11.1693ZM12.0276 6.05551H16.3189V1.76417H12.0276V6.05551ZM1.72835 7.77202C1.25432 7.77202 0.870083 7.38772 0.870083 6.91375V0.905875C0.870083 0.4319 1.25432 0.0476074 1.72835 0.0476074H7.73623C8.21025 0.0476074 8.59449 0.4319 8.59449 0.905875V6.91375C8.59449 7.38772 8.21025 7.77202 7.73623 7.77202H1.72835ZM2.58661 6.05551H6.87795V1.76417H2.58661V6.05551Z"
                    />
                  </svg>
                  <span>My Tasks</span>
                </a>
              </li>): null}
              {user.role != "agency" ? (
                <li
                  onClick={() => {
                    setMenu(false);
                  }}
                >
                  <Link to="/dashboard/analytics">
                    <svg viewBox="0 0 29 28" xmlns="http://www.w3.org/2000/svg">
                      <path
                        clipRule="evenodd"
                        d="M12.8508 27.6529C6.67037 26.8356 1.79125 22.0014 0.91675 15.8288C0.0423304 9.65621 3.38676 3.65698 9.09689 1.15513C9.73289 0.891969 10.4624 1.18659 10.7373 1.81752C11.0123 2.44853 10.7314 3.18339 10.1057 3.47015C5.42153 5.50355 2.67043 10.4131 3.38162 15.4697C4.09288 20.5264 8.09146 24.4867 13.1548 25.1491C18.218 25.8116 23.1008 23.0133 25.089 18.3098C25.2635 17.8935 25.6473 17.6024 26.0951 17.5464C26.543 17.4904 26.9866 17.6783 27.2582 18.0388C27.5297 18.3994 27.5878 18.8776 27.4103 19.2925C24.9939 25.0403 19.0333 28.4636 12.8509 27.6542L12.8508 27.6529ZM14.6416 15.1507C14.3071 15.1503 13.9865 15.017 13.7503 14.7802C13.5141 14.5433 13.3818 14.2223 13.3825 13.8878V1.26413C13.3811 0.567314 13.9449 0.00136155 14.6416 0C22.3037 0.00953087 28.5087 6.2257 28.5046 13.8877C28.505 14.2223 28.3724 14.5433 28.136 14.7802C27.8996 15.017 27.5789 15.1503 27.2442 15.1506L14.6416 15.1507ZM15.902 12.6249H25.9132C25.3288 7.3536 21.1723 3.18936 15.902 2.59512V12.6249Z"
                        fill="white"
                      />
                    </svg>
                    <span>Analytics</span>
                  </Link>
                </li>
              ) : null}
              {/*{user.role == "admin" || user.role === "hod" ? <li onClick={() => { setMenu(false) }}>
                                <Link to="/dashboard/clients">
                                    <svg viewBox="0 0 28 25" xmlns="http://www.w3.org/2000/svg">
                                        <path clipRule="evenodd" d="M19.0513 24.7863H4.1795C2.12612 24.7863 0.461548 23.1217 0.461548 21.0684V8.67521C0.461548 6.62184 2.12612 4.95726 4.1795 4.95726H7.89745V3.71795C7.89745 1.66457 9.56202 0 11.6154 0H16.5727C18.626 0 20.2906 1.66457 20.2906 3.71795V4.95726H24.0086C26.0619 4.95726 27.7265 6.62184 27.7265 8.67521V21.0684C27.7265 23.1217 26.0619 24.7863 24.0086 24.7863H19.0513ZM24.0085 22.3077C24.693 22.3077 25.2479 21.7529 25.2479 21.0684V8.67524C25.2479 7.99076 24.693 7.43593 24.0085 7.43593H20.2906V22.3077H24.0085ZM17.812 22.3077V7.43593H10.3761V22.3077H17.812ZM2.94017 8.67524V21.0684C2.94017 21.7529 3.49508 22.3077 4.17949 22.3077H7.89744V7.43593H4.17949C3.49508 7.43593 2.94017 7.99076 2.94017 8.67524ZM17.812 4.95729V3.71798C17.812 3.03349 17.2571 2.47866 16.5726 2.47866H11.6154C10.931 2.47866 10.3761 3.03349 10.3761 3.71798V4.95729H17.812Z" fill="white" />
                                    </svg>
                                    <span>Clients</span>
                                </Link>
                            </li> : null}*/}
              {user.role == "admin" ? (
                <li
                  onClick={() => {
                    setMenu(false);
                  }}
                >
                  <Link to="/dashboard/employees">
                    <i className="bx bx-user"></i>
                    <span>Employees</span>
                  </Link>
                </li>
              ) : null}
              {user.role == "admin" ? (
                <li
                  onClick={() => {
                    setMenu(false);
                  }}
                >
                  <Link to="/register">
                    <i className="bx bx-user"></i>
                    <span>Create Employees</span>
                  </Link>
                </li>
              ) : null}
              {user.role == "admin" ? (
                <li
                  onClick={() => {
                    setMenu(false);
                  }}
                >
                  <Link to="/register-admin">
                    <i className="bx bx-user"></i>
                    <span>Create Admin Account</span>
                  </Link>
                </li>
              ) : null}
            </ul>
            {/* For delay notification */}
          </div>
          {user.role != "agency" ? 
          <div className="d-flex align-items-center">
            <div className={styles.notification} ref={noteRef}>
              <button
                className={styles.noti_btn}
                onClick={() => {
                  setNoteContainer(!noteContainer);
                }}
              >
                <VscBell />
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {unreadNotificationsLength}
                  <span className="visually-hidden">unread messages</span>
                </span>
              </button>
              <NotificationContainer open={noteContainer} />
            </div>
            <button
              className={styles.iconBtn}
              onClick={() => {
                setMenu(!menu);
              }}
              ref={menuRef}
            >
              <i className="fa-solid fa-ellipsis"></i>
            </button>
          </div>: null}
        </div>
        <div
          className={`${styles.left_panel} ${openSide ? styles.active : null}`}
        >
          <button
            className={styles.leftBtn}
            onClick={() => {
              setOpenSide(!openSide);
            }}
          >
            <i className="fa-solid fa-ellipsis"></i>
          </button>
          <div className={styles.client}>
            {user.picture ? (
              <div className={styles.img}>
                {" "}
                <img
                  src={
                    process.env.REACT_APP_API_URL + `uploads/${user.picture}`
                  }
                  className="img-fluid"
                  alt=""
                />
              </div>
            ) : (
              <i className={`bx bxs-user-circle ${styles.img1}`}></i>
            )}
            <div className={styles.info}>
              <div className="w-100">
                <h6 className={styles.h6}>
                  {user ? (
                    user.username
                  ) : (
                    <Skeleton variant="text" className={styles.h6} />
                  )}
                </h6>
                <span className={styles.span}>
                  {user ? (
                    user.role == "employee" ? (
                      "Team Member"
                    ) : (
                      user.role
                    )
                  ) : (
                    <Skeleton variant="text" className={styles.h6} />
                  )}
                </span>
              </div>
              <Link
                data-toggle="tooltip"
                data-placement="bottom"
                title="Settings"
                to="/dashboard/setting/profile"
                onClick={() => {
                  setOpenSide(!openSide);
                }}
                style={{ color: "var(--BLACK)" }}
              >
                <i className="fa-solid fa-gear"></i>
              </Link>
            </div>
          </div>

          <h5>MENU</h5>
          <div className={styles.left_links}>
            <ul>
              {user.role !== "agency" && <li
                className={
                  location.pathname == "/dashboard" ? styles.active : ""
                }
                onClick={() => {
                  setOpenSide(false);
                }}
              >
                <a href="/dashboard">
                  <svg viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg">
                    <path
                      clipRule="evenodd"
                      d="M11.1693 17.213C10.6953 17.213 10.311 16.8287 10.311 16.3547V10.3469C10.311 9.87289 10.6953 9.4886 11.1693 9.4886H17.1772C17.6512 9.4886 18.0354 9.87289 18.0354 10.3469V16.3547C18.0354 16.8287 17.6512 17.213 17.1772 17.213H11.1693ZM12.0276 15.4965H16.3189V11.2051H12.0276V15.4965ZM1.72835 17.213C1.25432 17.213 0.870079 16.8287 0.870079 16.3547V10.3469C0.870079 9.87289 1.25432 9.4886 1.72835 9.4886H7.73622C8.21025 9.4886 8.59449 9.87289 8.59449 10.3469V16.3547C8.59449 16.8287 8.21025 17.213 7.73622 17.213H1.72835ZM2.58661 15.4965H6.87795V11.2051H2.58661V15.4965ZM11.1693 7.77205C10.6953 7.77205 10.311 7.38776 10.311 6.91378V0.905909C10.311 0.431934 10.6953 0.0476412 11.1693 0.0476412H17.1772C17.6512 0.0476412 18.0354 0.431934 18.0354 0.905909V6.91378C18.0354 7.38776 17.6512 7.77205 17.1772 7.77205H11.1693ZM12.0276 6.05551H16.3189V1.76417H12.0276V6.05551ZM1.72835 7.77202C1.25432 7.77202 0.870083 7.38772 0.870083 6.91375V0.905875C0.870083 0.4319 1.25432 0.0476074 1.72835 0.0476074H7.73623C8.21025 0.0476074 8.59449 0.4319 8.59449 0.905875V6.91375C8.59449 7.38772 8.21025 7.77202 7.73623 7.77202H1.72835ZM2.58661 6.05551H6.87795V1.76417H2.58661V6.05551Z"
                    />
                  </svg>
                  <span>My Tasks </span>
                </a>
              </li>}
              {user.role === "admin" || user.role === "hod" ? (
                <li
                  className={
                    location.pathname == "/dashboard/group" ? styles.active : ""
                  }
                  onClick={() => {
                    setOpenSide(false);
                  }}
                >
                  <Link to="group">
                    <i className="bx bx-group"></i>
                    <span>Groups </span>
                  </Link>
                </li>
              ) : null}
              {user.role !== "agency" ? <li
                className={
                  location.pathname == "/dashboard/chatbot" ? styles.active : ""
                }
                onClick={() => {
                  setOpenSide(false);
                }}
              >
                <Link to="chatbot" id="mbtn-1">
                  <svg
                    width="128"
                    height="128"
                    viewBox="0 0 64 64"
                    aria-hidden="true"
                    role="img"
                  >
                    <path
                      d="M22.625 2c0 15.834-8.557 30-20.625 30c12.068 0 20.625 14.167 20.625 30c0-15.833 8.557-30 20.625-30c-12.068 0-20.625-14.166-20.625-30"
                      fill="#000000"
                    />
                    <path
                      d="M47 32c0 7.918-4.277 15-10.313 15C42.723 47 47 54.084 47 62c0-7.916 4.277-15 10.313-15C51.277 47 47 39.918 47 32z"
                      fill="#000000"
                    />
                    <path
                      d="M51.688 2c0 7.917-4.277 15-10.313 15c6.035 0 10.313 7.084 10.313 15c0-7.916 4.277-15 10.313-15c-6.036 0-10.313-7.083-10.313-15"
                      fill="#000000"
                    />
                  </svg>
                  <span>AI </span>
                </Link>
              </li>: null}
              {user.role === "admin" || user.role === "hod" ? <li
                className={
                  location.pathname == "/dashboard/agencies" ? styles.active : ""
                }
                onClick={() => {
                  setOpenSide(false);
                }}
              >
                <Link to="agencies" id="mbtn-1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"/></svg>
                {/* <MdOutlineBusiness size={18} color="blue" /> */}
                <span>Agencies</span>

                </Link>
              </li>: null}
              <li
                className={
                  location.pathname == "/dashboard/support" ? styles.active : ""
                }
                onClick={() => {
                  setOpenSide(false);
                }}
              >
                <Link to="support" id="mbtn-1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                <span>{user.role != "agency" ? "Support" : "Requests"}</span>

                </Link>
              </li>
            </ul>

            <ul>
              <li
                className="mb-0"
                onClick={() => {
                  setModal({ open: true, component: "Confirm" });
                  setConfirm({
                    component: "Logout",
                    promise: false,
                    text: "Are You Sure You want to Logout ?",
                  });
                  setOpenSide(false);
                }}
              >
                <Link>
                  <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                    <path
                      clipRule="evenodd"
                      d="M5.16571 21.1377C2.61941 21.1643 0.50239 19.1837 0.359433 16.6414L0.353409 16.4258V5.21172C0.373996 2.66541 2.39766 0.587633 4.94255 0.499837L5.16314 0.494598H10.1823C12.7309 0.464634 14.8516 2.44582 14.9947 4.99045L14.9997 6.15233C14.9897 6.68687 14.5721 7.12501 14.0385 7.16042C13.5049 7.19604 13.0328 6.8172 12.9519 6.28853L12.9442 6.16952V5.21256C12.93 3.76632 11.79 2.58223 10.3454 2.51329L10.1737 2.50805H5.16744C3.72053 2.49506 2.51343 3.61043 2.41233 5.05373L2.40809 5.22031V16.4216C2.4227 17.8668 3.56154 19.05 5.00521 19.12L5.17687 19.1253H10.1926C11.6341 19.1393 12.8374 18.0289 12.939 16.5909L12.9442 15.4829C12.9566 14.9498 13.3735 14.5146 13.9053 14.4792C14.4371 14.4438 14.9081 14.8199 14.9912 15.3462L14.9997 15.4657V16.4321C14.978 18.9706 12.9621 21.0425 10.4252 21.1337L10.1986 21.1389L5.16571 21.1377ZM17.2141 14.4638C16.8568 14.1128 16.8153 13.5513 17.1171 13.1515L17.2029 13.0528L18.4629 11.822H8.57218C8.03759 11.8306 7.58965 11.4196 7.55246 10.8862C7.51521 10.3529 7.90165 9.88352 8.43226 9.81794L8.55416 9.80935H18.4646L17.2167 8.59403C16.8577 8.2441 16.8144 7.68212 17.1154 7.28148L17.2012 7.18384C17.5649 6.82343 18.1348 6.77524 18.5538 7.06985L18.6551 7.15555L21.6676 10.0916C21.8697 10.2789 21.984 10.5423 21.9827 10.8176C21.9814 11.0957 21.8644 11.3608 21.6599 11.5489L18.6689 14.467C18.2639 14.8592 17.6208 14.8592 17.2158 14.467L17.2141 14.4638Z"
                      fill="#384455"
                    />
                  </svg>
                  <span>Logout </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
